const $inject = ['$uibModalInstance', 'data'];

const lbaDeleteConfirmCtrl = function ($uibModalInstance, data) {
  let vm = this;

  vm.displayName = data.displayName;
  vm.id = data.Id;

  vm.ok = function () {
    document.location.reload(true);
  };

};


lbaDeleteConfirmCtrl.$inject = $inject;

export default lbaDeleteConfirmCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaAddGridResource/lbaSaveCallbackCtrl.js